module.exports = __webpack_public_path__ + "img/delete-touming.ded64c07.svg";